import {
    Layout,
    Button,
    Page,
    Frame,
    LegacyStack,
} from '@shopify/polaris';

import {useCallback, useEffect, useState} from 'react';
import OrdersSearch from "./OrdersSearch";
import Api from "../../helpers/api";

const OrdersList = () => {
    const [searchType, setSearchType] = useState('sales_rep');
    const [loading, setLoading] = useState(false);
    const [exportModalActive, setExportModalActive] = useState(false);
    const [user, setUser] = useState();


    useEffect(() => {
        Api
            .getMe()
            .then(({data}) => {
                setUser(data.user);
            })
    }, []);

    return (
        <Frame>
            <Page title="Orders">
                <Layout>
                    <OrdersSearch
                        searchType={searchType}
                        loading={loading}
                        setLoading={setLoading}
                        exportModalActive={exportModalActive}
                        setExportModalActive={setExportModalActive}
                    />
                </Layout>
            </Page></Frame>
    );
}

export default OrdersList;
